if (process.env.NODE_ENV === 'production') {
  module.exports = require('./render-logic.production.js');
} else {
  module.exports = require('./render-logic.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/render-logic/dist/es/render-logic.js
// module id = 283
// module chunks = 0